import React from "react";

const SearchIcon = () => {
  return (
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.2656 9.02847H9.61682L9.38688 8.80687C10.3723 7.65786 10.8815 6.09028 10.6023 4.42421C10.2163 2.1426 8.3111 0.320596 6.01173 0.0415496C2.53804 -0.385226 -0.385452 2.53655 0.041574 6.00821C0.320784 8.30623 2.14386 10.2103 4.42681 10.5961C6.09385 10.8751 7.66235 10.3662 8.81204 9.38138L9.03376 9.61118V10.2596L12.5239 13.7476C12.8606 14.0841 13.4108 14.0841 13.7475 13.7476C14.0842 13.4111 14.0842 12.8612 13.7475 12.5248L10.2656 9.02847ZM5.33834 9.02847C3.29354 9.02847 1.64292 7.37882 1.64292 5.33521C1.64292 3.29161 3.29354 1.64196 5.33834 1.64196C7.38314 1.64196 9.03376 3.29161 9.03376 5.33521C9.03376 7.37882 7.38314 9.02847 5.33834 9.02847Z" fill="#1D242E"/>
</svg>

  );
};

export default SearchIcon;